import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'

import './assets/site.css'
import './assets/fonts/iconfont.css'


import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);


Vue.config.productionTip = false

var vueParent = new Vue({
  router,
  render: h => h(App)
}).$mount('#app');


//全局配置ajax
(function () {
  $.ajaxSetup({
    xhrFields: {
      withCredentials: true  //支持附带详细信息
    },
    crossDomain: true,//请求偏向外域
    // contentType: 'application/x-www-form-urlencoded',
    error: res => {
      //请求异常处理登录
      if (res.status == 599) {
        //当前用户没有登录
        vueParent.$message({
          type: 'error',
          message: '您没有登录或登录超时',
          onClose: () => {
            vueParent.$router.replace('login');
          }
        });
      }
    }
  });


  Date.prototype.toLocaleString = function () {   // 重写日期函数格式化日期
    return `${this.getFullYear()}-${this.getMonth() + 1 >= 10 ? (this.getMonth() + 1) : '0' + (this.getMonth() + 1)}-${this.getDate() >= 10 ? this.getDate() : '0' + this.getDate()} ${this.getHours() >= 10 ? this.getHours() : '0' + this.getHours()} : ${this.getMinutes() >= 10 ? this.getMinutes() : '0' + this.getMinutes()} : ${this.getSeconds() >= 10 ? this.getSeconds() : '0' + this.getSeconds()}`;
  };

   //js 日期格式化
   Date.prototype.format = function (fmt) {
    var o = {
      "M+": this.getMonth() + 1,                 //月份 
      "d+": this.getDate(),                    //日 
      "h+": this.getHours(),                   //小时 
      "m+": this.getMinutes(),                 //分 
      "s+": this.getSeconds(),                 //秒 
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
      "S": this.getMilliseconds()             //毫秒 
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
    }
    return fmt;
  }

})();
